import React from 'react';
import {Box, type BoxProps} from '@mui/material';

interface IconWrapperProps {
  size?: 'large' | 'medium' | 'small';
  children: React.ReactNode;
}

function IconWrapper({
  size,
  children,
  ...boxProps
}: IconWrapperProps & BoxProps) {
  const sizeMap = {
    large: 80,
    medium: 50,
    small: 32,
  };

  let height: number;
  const width = (height = size ? sizeMap[size] : 80);

  const styles = {
    border: '1px solid #eee',
    bgcolor: '#fff',
    borderRadius: '6px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: `${width}px`,
    height: `${height}px`,
    ...boxProps.sx,
  };

  return (
    <Box {...boxProps} sx={styles}>
      {children}
    </Box>
  );
}

export default IconWrapper;
